export default __webpack_public_path__ + "static/media/Ad_Bild_2.56e94da4.jpg";